import React from 'react'
import { Box, useTheme } from '@mui/material'
import { BarValue } from '../types'
import { FIGMA_ACCENT_COLORS } from '../../../../style/colors'

interface HorizontalBarChartProps {
    values: BarValue[]
    maxValue: number
}

const HorizontalBarChart = ({ values, maxValue }: HorizontalBarChartProps) => {
    const theme = useTheme()
    const totalValue = values.reduce((sum, item) => sum + item.value, 0)
    const safeMaxValue = maxValue || 1

    return (
        <Box
            sx={{
                width: '100%',
                height: 8,
                display: 'flex',
                borderRadius: 4,
                overflow: 'hidden',
                backgroundColor: theme.palette.figma.grayscale.tier6,
            }}
        >
            {values.map((item, index) => {
                const widthPercentage = (item.value / safeMaxValue) * 100
                return (
                    <Box
                        key={index}
                        sx={{
                            width: `${widthPercentage}%`,
                            height: '100%',
                            backgroundColor: item.color || FIGMA_ACCENT_COLORS.blue,
                        }}
                    />
                )
            })}
        </Box>
    )
}

export default HorizontalBarChart
